document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".custome-swiper", {
    slidesPerView: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      525: {
        slidesPerView: 1.5
      },
      750: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3
      }
    },
  });
});
